// src/slices/weather/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getWeather } from "./thunk";

const initialState = { list: [], loading: false, error: null };

const weatherSlice = createSlice({
  name: "weather",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      .addCase(getWeather.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getWeather.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })

      .addCase(getWeather.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default weatherSlice.reducer;
